// extracted by mini-css-extract-plugin
export var button = "Header-module--button--M6UvQ";
export var hamburger = "Header-module--hamburger--HOUmj";
export var header = "Header-module--header--kDEtM";
export var span = "Header-module--span--wcb86";